export default class ApiAccounts {
	accounts: object[];
	totalCount: number;

	constructor(accounts: object[], totalCount: number) {
		this.accounts = accounts;
		this.totalCount = totalCount;
	}
}
